let reportSummarySelects = {}

reportSummarySelects.summaryReport = [
  {
    header: 'Desks'
  },
  {
    text: 'Desk Occupancy by day of week',
    disabled: false,
    value: {
      display_metric: 'occupancy',
      space_filters: [{ group: 'space_type', allow_values: ['Desk'] }],
      time_granularity: 'day_of_week',
      sample_period: 'last28days',
      graph_type: 'simplebar',
      graph_groups: [''],
      notes: ''
    }
  },
  {
    text: 'Desk Occupancy by week',
    disabled: false,
    value: {
      display_metric: 'occupancy',
      space_filters: [{ group: 'space_type', allow_values: ['Desk'] }],
      time_granularity: 'week',
      sample_period: 'last4fullweeks',
      graph_type: 'simplebar',
      graph_groups: [''],
      notes: ''
    }
  },
  {
    text: 'Desk Utilisation by day of week',
    disabled: false,
    value: {
      display_metric: 'utilisation',
      space_filters: [{ group: 'space_type', allow_values: ['Desk'] }],
      time_granularity: 'day_of_week',
      sample_period: 'last28days',
      graph_type: 'simplebar',
      graph_groups: [''],
      notes: ''
    }
  },
  {
    text: 'Desk Utilisation by week',
    disabled: false,
    value: {
      display_metric: 'utilisation',
      space_filters: [{ group: 'space_type', allow_values: ['Desk'] }],
      time_granularity: 'week',
      sample_period: 'last4fullweeks',
      graph_type: 'simplebar',
      graph_groups: ['space_type'],

      notes: ''
    }
  },
  {
    header: 'Managed Spaces'
  },
  {
    text: 'Managed space air quality by day of week',
    disabled: true,
    value: {
      display_metric: 'Air Quality',
      space_filters: [],
      time_granularity: 'day_of_week',
      sample_period: 'last28days',

      notes: 'Min, Max, Average. Min and Max as lines, Average as bar'
    }
  },
  {
    text: 'Managed space capacity uptake by day of week',
    disabled: false,
    value: {
      display_metric: 'Capacity in Use',
      space_filters: [],
      time_granularity: 'day_of_week',
      sample_period: 'last28days',
      notes: 'Show occupancy % but only for the periods where the space was in use. Meaning that for when the space was used, how well was it used'
    }
  },
  {
    text: 'Managed space capacity uptake by week',
    disabled: true,
    value: {
      display_metric: 'Capacity in Use',
      space_filters: [],
      time_granularity: 'week',
      sample_period: 'last4fullweeks',

      notes: 'Show occupancy % but only for the periods where the space was in use. Meaning that for when the space was used, how well was it used'
    }
  },
  {
    text: 'Managed space humidity level by day of week',
    disabled: true,
    value: {
      display_metric: 'Humidity',
      space_filters: [],
      time_granularity: 'day_of_week',
      sample_period: 'last28days',

      notes: 'Min, Max, Average. Min and Max as lines, Average as bar'
    }
  },
  {
    text: 'Managed space light level by day of week',
    disabled: true,
    value: {
      display_metric: 'Light Level',
      space_filters: [],
      time_granularity: 'day_of_week',
      sample_period: 'last28days',

      notes: 'Min, Max, Average. Min and Max as lines, Average as bar'
    }
  },
  {
    text: 'Managed space occupancy by day of week',
    disabled: true,
    value: {
      display_metric: 'occupancy',
      space_filters: [],
      time_granularity: 'day_of_week',
      sample_period: 'last28days',
      graph_type: 'simplebar',
      graph_groups: ['space_type'],

      notes: ''
    }
  },
  {
    text: 'Managed space occupancy by week',
    disabled: true,
    value: {
      display_metric: 'occupancy',
      space_filters: [],
      time_granularity: 'week',
      sample_period: 'last4fullweeks',
      graph_type: 'simplebar',
      graph_groups: ['space_type'],

      notes: ''
    }
  },
  {
    text: 'Managed space sound level by day of week',
    disabled: true,
    value: {
      display_metric: 'Sound Level',
      space_filters: [],
      time_granularity: 'day_of_week',
      sample_period: 'last28days',

      notes: 'Min, Max, Average. Min and Max as lines, Average as bar'
    }
  },
  {
    text: 'Managed space temperature level by day of week',
    disabled: true,
    value: {
      display_metric: 'Temperature',
      space_filters: [],
      time_granularity: 'day_of_week',
      sample_period: 'last28days',

      notes: 'Min, Max, Average. Min and Max as lines, Average as bar'
    }
  },
  {
    text: 'Managed space utilisation by day of week',
    disabled: true,
    value: {
      display_metric: 'utilisation',
      space_filters: [],
      time_granularity: 'day_of_week',
      sample_period: 'last28days',
      graph_type: 'simplebar',
      graph_groups: ['space_type'],

      notes: ''
    }
  },
  {
    text: 'Managed space utilisation by week',
    disabled: true,
    value: {
      display_metric: 'utilisation',
      space_filters: [],
      time_granularity: 'week',
      sample_period: 'last4fullweeks',
      graph_type: 'simplebar',
      graph_groups: ['space_type'],

      notes: ''
    }
  },
  {
    header: 'Meeting Rooms'
  },
  {
    text: 'Meeting room average occupants by day of week',
    disabled: true,
    value: {
      display_metric: 'Average Occupants',
      space_filters: [{ group: 'space_type', allow_values: ['Meeting Room'] }],
      time_granularity: 'day_of_week',
      sample_period: 'last28days',
      graph_type: 'simplebar',
      graph_groups: ['space_type'],

      notes: ''
    }
  },
  {
    text: 'Meeting room average occupants by week',
    disabled: true,
    value: {
      display_metric: 'Average Occupants',
      space_filters: [{ group: 'space_type', allow_values: ['Meeting Room'] }],
      time_granularity: 'week',
      sample_period: 'last4fullweeks',
      graph_type: 'simplebar',
      graph_groups: ['space_type'],

      notes: ''
    }
  },
  {
    text: 'Meeting room capacity uptake by day of week',
    disabled: true,
    value: {
      display_metric: 'Capacity in Use',
      space_filters: [{ group: 'space_type', allow_values: ['Meeting Room'] }],
      time_granularity: 'day_of_week',
      sample_period: 'last28days',

      notes: 'Show occupancy % but only for the periods where the space was in use. Meaning that for when the space was used, how well was it used'
    }
  },
  {
    text: 'Meeting room capacity uptake by week',
    disabled: true,
    value: {
      display_metric: 'Capacity in Use',
      space_filters: [{ group: 'space_type', allow_values: ['Meeting Room'] }],
      time_granularity: 'week',
      sample_period: 'last4fullweeks',

      notes: 'Show occupancy % but only for the periods where the space was in use. Meaning that for when the space was used, how well was it used'
    }
  },
  {
    text: 'Meeting durations by day of week',
    disabled: true,
    value: {
      display_metric: 'Meeting Room Use',
      space_filters: [{ group: 'space_type', allow_values: ['Meeting Room'] }],
      time_granularity: 'day_of_week',
      sample_period: 'last28days',

      notes: 'Bands of 1-5 mins, 6-15 mins, 16-30 mins, greater than 30 mins'
    }
  },
  {
    text: 'Meeting room occupancy by day of week',
    disabled: true,
    value: {
      display_metric: 'occupancy',
      space_filters: [{ group: 'space_type', allow_values: ['Meeting Room'] }],
      time_granularity: 'day_of_week',
      sample_period: 'last28days',
      graph_type: 'simplebar',
      graph_groups: ['space_type'],

      notes: ''
    }
  },
  {
    text: 'Meeting room occupancy by week',
    disabled: true,
    value: {
      display_metric: 'occupancy',
      space_filters: [{ group: 'space_type', allow_values: ['Meeting Room'] }],
      time_granularity: 'week',
      sample_period: 'last4fullweeks',
      graph_type: 'simplebar',
      graph_groups: ['space_type'],

      notes: ''
    }
  },
  {
    text: 'Meeting room occupancy efficiency by day of week',
    disabled: true,
    value: {
      display_metric: 'Occupancy Efficiency',
      space_filters: [{ group: 'space_type', allow_values: ['Meeting Room'] }],
      time_granularity: 'day_of_week',
      sample_period: 'last28days',

      notes: 'Modal Occupants / Capacity'
    }
  },
  {
    text: 'Meeting room occupancy efficiency by week',
    disabled: true,
    value: {
      display_metric: 'Occupancy Efficiency',
      space_filters: [{ group: 'space_type', allow_values: ['Meeting Room'] }],
      time_granularity: 'week',
      sample_period: 'last4fullweeks',

      notes: 'Modal Occupants / Capacity'
    }
  },
  {
    text: 'Meeting room utilisation by day of week',
    disabled: true,
    value: {
      display_metric: 'utilisation',
      space_filters: [{ group: 'space_type', allow_values: ['Meeting Room'] }],
      time_granularity: 'day_of_week',
      sample_period: 'last28days',
      graph_type: 'simplebar',
      graph_groups: ['space_type'],

      notes: ''
    }
  },
  {
    text: 'Meeting room utilisation by week',
    disabled: true,
    value: {
      display_metric: 'utilisation',
      space_filters: [{ group: 'space_type', allow_values: ['Meeting Room'] }],
      time_granularity: 'week',
      sample_period: 'last4fullweeks',
      graph_type: 'simplebar',
      graph_groups: ['space_type'],

      notes: ''
    }
  },
  {
    header: 'Space Type Analysis'
  },
  {
    text: 'Occupancy for each space type by day of week',
    disabled: true,
    value: {
      display_metric: 'occupancy',
      space_filters: [],
      time_granularity: 'day_of_week',
      sample_period: 'last28days',
      graph_type: 'spacetypefourgraphs',

      notes: ''
    }
  },
  {
    text: 'Occupancy for each space type by week',
    disabled: true,
    value: {
      display_metric: 'occupancy',
      space_filters: [],
      time_granularity: 'week',
      sample_period: 'last4fullweeks',
      graph_type: 'spacetypefourgraphs',

      notes: ''
    }
  },
  {
    text: 'Utilisation for each space type by day of week',
    disabled: true,
    value: {
      display_metric: 'utilisation',
      space_filters: [],
      time_granularity: 'day_of_week',
      sample_period: 'last28days',
      graph_type: 'spacetypefourgraphs',

      notes: ''
    }
  },
  {
    text: 'Utilisation for each space type by week',
    disabled: true,
    value: {
      display_metric: 'utilisation',
      space_filters: [],
      time_granularity: 'week',
      sample_period: 'last4fullweeks',
      graph_type: 'spacetypefourgraphs',

      notes: ''
    }
  }
]

export default reportSummarySelects
